export class CesionarioFilter {
   public rut: string = "";
   public dv: string = "";
   public razonSocial: string = "";
   public direccion: string = "";
   public emisorId: string;
   public activo: number;
}
